import React, { useMemo } from 'react';
import { Typo, Page, Button, Flex } from '../../ui';
import { useSettings } from '../settings/hooks';
import { useNotes } from './hooks';
import styled from 'styled-components';
import { CONTENT_SMALL } from '../../utils/media';
import { useTranslation } from 'react-i18next';
import NotesOverview from './components/NotesOverview';
import { saveAllNotesToDocx } from '../../utils/docxNotesGenerator';
import { useRefetchOnAuthChange } from '../auth/hooks';
import PageSection from '../../ui/Page/PageSection';

const CourseBlock = styled.div`
  width: 100%;
  margin: 1rem 0;
  &:not(:first-child) {
    margin: 3rem 0;
  }
`;

const Notes = () => {
  const { t } = useTranslation();

  const { notesData = [], refetch } = useNotes();
  useRefetchOnAuthChange(refetch);

  const { settings } = useSettings();
  const features = settings.features || {};

  const courses = useMemo(() => {
    if (!notesData || notesData.length === 0) return [];

    return notesData.map((course) => ({
      ...course,
      sections: Array.isArray(course.sections) ? course.sections : [],
    }));
  }, [notesData]);

  return (
    <Page size={CONTENT_SMALL}>
      <PageSection>
        {courses.length ? (
          <>
            <Flex alignSelf='end'>
              <Button icon={'Save'} onClick={() => saveAllNotesToDocx(courses)}>
                {t('notes.saveAll')}
              </Button>
            </Flex>
            {courses.map((course) => (
              <CourseBlock key={course.id}>
                <Typo.ContentBigHeader $textAlign='left'>{course.name}</Typo.ContentBigHeader>
                <NotesOverview notes={course.sections} course={course} features={features} />
              </CourseBlock>
            ))}
          </>
        ) : (
          <Typo.ContentSmallHeader>{t('notes.emptyStateMsg')}</Typo.ContentSmallHeader>
        )}
      </PageSection>
    </Page>
  );
};

export default Notes;
